import {IMuWidget} from "./IMuWidget";
import {SavedFiltersCL} from "./generated/SavedFiltersCL";

export class UiSavedFilters extends IMuWidget {

	public clUrl: string;

	public adminUrl: string;

	protected cl: SavedFiltersCL;

	private tree: any;

	public showLinkTemplate: string;

	beforeIndex() {
		this.container.innerHTML = `
			<span mu-id="bOpen" class="saved-filters--opener">` + this.container.innerHTML + `</span>
			<span mu-id="content">
				<span class="saved-filters__content">
					<span class="modal-b--transparent" mu-id="modalBg" style="z-index: auto"></span>
					<span mu-id="tree"></span>
					<a mu-id="adminLink" class="display-block strong" style="position: relative">Všechny přehledy</a>					
				</span>
			</span>`;
		this.container.classList.add('saved-filters')	;
	}

	modalBg_click() {
		this.container.classList.remove('saved-filters--open');
	}

	bOpen_click() {
		this.container.classList.toggle('saved-filters--open');
	}

	async afterIndex() {
		this.cl = new SavedFiltersCL(this.clUrl);
		const data = await this.cl.getMySavedFilters();
		this.ui.adminLink.href = this.adminUrl;
		this.tree = $(this.ui.tree).fancytree({
			source: data,
			activate: (event: PointerEvent, data) => {
				console.log(event);
				if( data.node.isFolder() ){
					data.node.toggleExpanded();
					return false;
				}

				const url = this.showLinkTemplate.replace('{id}', data.node.key.split('_')[1]);
				if (event.ctrlKey) window.open(url);
				else document.location = url;
			},
			keypress: (event, data) => {

			}
		}).fancytree('getTree');
	}
}